import QCollapse from './src/collapse';


export default QCollapse;

